import $ from 'jquery'
export default {
    name: 'assure-consommables',
    components: {},
    props: {
        list_exclu_consommables: Array
    },
    data() {
        return {
            all_checked: false,
            one_is_checked: [],
			each_cat_is_checked: [],
            text_grey: []
        }
    },

    watch: {
        one_is_checked() {
            this.$store.commit('SET_EXCLU_CONSOMMABLE', this.one_is_checked)
        }
    },

    computed: {
        liste_consommables() {
            return this.$store.getters["liste_consommables"];
        },
    },

    mounted() {
        this.listeConsommables()
    },

    methods: {
        listeConsommables() {
            this.$store.dispatch('getListeConsommables').then(() => {
                if (this.liste_consommables.length > 0) {
                    this.setSelectedConsommables()
                } 
            }).then(() => { this.$store.commit('SET_EXCLU_CONSOMMABLE', this.one_is_checked); this.$emit('pret') }).catch(() => { this.$emit('erreur') })
        },

        setSelectedConsommables() {
			this.one_is_checked = []
            this.text_grey = []

            this.list_exclu_consommables.forEach(exclusion => {
                this.liste_consommables.forEach(consommable => {
					if (exclusion.id == consommable.id) {
                        this.text_grey[consommable.id] = 'text-grey'
                        this.one_is_checked.push(consommable.id)
                    } 
                });
            });
		},

        toutSelectionner() {
            let is_checked = $('#all-consumable').is(":checked")
            this.toggleAllChecked(is_checked)
        },

        toggleAllChecked(is_checked) {
            this.one_is_checked = []
            this.each_cat_is_checked = []
            
            this.liste_consommables.forEach((consommable) => {
                if (is_checked) {
                    this.one_is_checked.push(consommable.id)
                }
                this.text_grey[consommable.id] = (is_checked)?'text-grey':''
            });
            
            this.all_checked = is_checked
        },

        onExclu(index) {
            let is_checked = $('#consumable'+index).is(":checked")

            let c = ''
            if (is_checked == true) {
                c = 'text-grey'
            }
            this.text_grey[index] = c
        },
    }
}
